import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs/index';
import {AnalyticsService} from '../analytics.service';
import {AppStateService} from '../app-state.service';
import {AuthService} from '../auth.service';
import {ModalComponent} from '../modal/modal.component';
import {StorageService} from '../storage.service';
import {ApiService} from '../api.service';
import {ClientApiService} from '../../client/client-api.service';

const MAX_STEP = 7;
const DIVERSITY_INSIGHTS_INDEX = 7;

@Component({
  selector: 'onboarding-modal',
  templateUrl: './onboarding-modal.component.html',
  styleUrls: ['./onboarding-modal.component.scss']
})
export class OnboardingModalComponent implements OnInit {

  @ViewChild('modal') modal: ModalComponent;

  user: User;

  step$ = new BehaviorSubject<number>(0);
  maxStep = MAX_STEP;
  brand$ = this.AppState.brand$;
  locale$ = this.AppState.locale$;
  isAustralia$ = this.AppState.isAustralia$;
  showOnlyDiversityInsights = false;
  diversityInsightsTutorialFeatureFlagEnabled = true;

  constructor(private Storage: StorageService,
              private Analytics: AnalyticsService,
              private Auth: AuthService,
              private AppState: AppStateService,
              private Api: ApiService,
              private ClientApi: ClientApiService) {
  }

  ngOnInit() {
    this.ClientApi.readFeature('diversity-insights-tutorial').subscribe(
      feature => {
        this.diversityInsightsTutorialFeatureFlagEnabled = feature;
        if (!feature) {
          this.maxStep -= 1;
        }
      },
      error => { console.log('Could not read feature flag: ' + error); },
      () => {
        this.getUserDetails();
      }
    );
  }

  getUserDetails() {
    this.Auth.user$.subscribe(user => {
      this.user = user;
      if (user && !user.admin) {
        if (!user.tutorialSeen) {
          this.show();
        } else if (!user.diversityTutorialSeen && this.diversityInsightsTutorialFeatureFlagEnabled) {
          this.maxStep = 0;
          this.showOnlyDiversityInsights = true;
          this.step$.next(DIVERSITY_INSIGHTS_INDEX);
          this.modal.show();
        }
      }
    });
  }

  show() {
    this.resetModal();
    this.step$.next(0);
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  onHide() {
    const updateDiversity = this.diversityInsightsTutorialFeatureFlagEnabled;
    const isMasquerading = this.Auth.masquerading$.getValue();
    if (!isMasquerading) {
      this.Api.updateTutorialAndDiversityTutorialSeenStatus(this.user.personId, true, updateDiversity)
        .subscribe(() => {},
          error => {
            console.log('Could not update the tutorial seen status');
          });
    }
  }

  next() {
    const step = this.step$.getValue() + 1;
    this.step$.next(step);
    this.Analytics.trackEvent('Onboarding: View page ' + step);
  }

  prev() {
    const step = this.step$.getValue() - 1;
    this.step$.next(step);
    this.Analytics.trackEvent('Onboarding: View page ' + step);
  }

  get step() {
    return this.step$.getValue();
  }

  resetModal() {
    // This was the cleanest way to do this. If another screen gets added to the tutorial,
    // then it needs to be added before the diversity insights screen.
    this.maxStep = this.diversityInsightsTutorialFeatureFlagEnabled ? MAX_STEP : MAX_STEP - 1;
    this.showOnlyDiversityInsights = false;
  }
}
